import Vue from 'vue'
import Router from 'vue-router'
import { setTitle } from '@/utils'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    // 路由切换，简单的让页面滚动到顶部
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // title默认 即刻天气
  const { title } = to.meta;
  if (title) setTitle(title);

  next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js